import { schema } from 'normalizr';

import { processGroupLinks } from '../strategies/groupLink';

export const groupLinksSchema: schema.Entity = new schema.Entity(
  'groupLinks',
  {},
  { processStrategy: processGroupLinks }
);
